import type { ChangelogEntry } from "../types";

/** Nøkkeltall på ansattkortet: faktureringsgrad og drillpanel på alle kort. */
export const ANSATTKORT_DRILLDOWN_2026_10: ChangelogEntry = {
  id: "2026-10-29-ansattkort-drilldown",
  date: "2026-10-29",
  title: "Grunnlaget bak hvert nøkkeltall på ansattkortet",
  summary: "Alle kortene i Nøkkeltall åpner et panel med utregningen og prosjektene bak, og faktureringsgrad har erstattet solgt mot loggført.",
  sections: [
    {
      heading: "Ansatte",
      items: [
        {
          title: "Klikk på et nøkkeltall for å se grunnlaget",
          kind: "forbedret",
          minRole: "admin",
          body: "Alle åtte kortene åpner et panel til høyre, som på Måltall. Panelet viser utregningen med de faktiske tallene og radene bak, med lenke til hvert prosjekt.",
        },
        {
          title: "Faktureringsgrad i stedet for solgt mot loggført",
          kind: "forbedret",
          minRole: "admin",
          body: "Kortet viser faktureringsgraden hittil i år mot den ansattes mål. Panelet viser hver måned. Solgt mot loggført per prosjekt står fortsatt i fanen Prosjekter.",
        },
      ],
    },
  ],
};
